import React from "react";
import PageWrapper from "../layouts/PageWrapper";
import { useElectronicDataRequests } from "../../hooks/useElectronicDataRequests";
import { IonItem, IonLabel, IonLoading } from "@ionic/react";
import moment from "moment";

const ElectronicDataRequestsPage: React.FC = () => {
  const { electronicDataRequests, electronicDataRequestsLoading, fetchElectronicDataRequests } = useElectronicDataRequests();
  return (
    <PageWrapper>
      <div className="hasButton">
        <h1 className="pageTitle">Elektronikus adatbekérő</h1>
      </div>
      {electronicDataRequests.map((edr) => (
        <IonItem lines="none" button={true} detail={true} routerDirection="none" routerLink={`/electronic-data-request/${edr.UID}`}>
          <IonLabel>
            {edr.base_data_customer?.base_data?.name ?? ""}
            {" - "}
            {moment(edr.created_at).format("YYYY.MM.DD.")}
          </IonLabel>
        </IonItem>
      ))}
      <IonLoading isOpen={electronicDataRequestsLoading} message="Kérjük várjon..." />
    </PageWrapper>
  );
};

export default ElectronicDataRequestsPage;
